<div class="flex flex-col gap-2">
  @if (!isDesktop) {
    <div class="text-neutral-900 text-2xl font-semibold leading-[32px]">
      {{ 'catalog.title1' | translate }}
    </div>
  }
  <div class="text-zinc-500 text-sm font-normal leading-[21px]">
    {{ 'catalog.title2' | translate }}
  </div>
  <div class="mt-[40px] flex gap-4 catalog-switcher" [class.flex-row]="isDesktop" [class.flex-col]="!isDesktop">
    <div class="flex-col flex gap-1 w-full">
      <span
        class="grow shrink basis-0 text-neutral-900 text-xs font-semibold leading-none"
      >
        {{ 'common.country' | translate }}
      </span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [formControl]="salesOrgControl" name="salesOrg" [class.desktop-scrollbar]="isDesktop">
          @for (salesOrg of sortedSalesOrgs; track salesOrg) {
            <mat-option [value]="salesOrg.value">
              {{ 'catalog.salesorg.' + salesOrg.value | lowercase | translate }}
            </mat-option>
          }
        </mat-select>
        @if (salesOrgControl.hasError('required')) {
          <mat-error>
            {{ 'catalog.errors.salesorg_required' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="flex-col flex gap-1 w-full">
      <span
        class="grow shrink basis-0 text-neutral-900 text-xs font-semibold leading-none"
      >
        {{ 'common.language' | translate }}
      </span>

      <mat-form-field appearance="outline" class="w-100">
        <mat-select [formControl]="languageControl" name="language">
          @for (language of (currentLanguages$ | async); track language) {
            <mat-option [value]="language.value">
              {{ 'catalog.languages.' + language.value | lowercase | translate }}
            </mat-option>
          }
        </mat-select>
        @if (languageControl.hasError('required')) {
          <mat-error>
            {{ 'catalog.errors.language_required' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="flex" [class.desktop-actions]="isDesktop" [class.flex-col]="!isDesktop">
    @if (shoppingCartContent$ | async; as cart) {
      @if (isDesktop) {
        <button
          (click)="onCancel()"
          [disabled]="form.invalid"
          dsw-secondary-button
          dsw-medium-button
          class="mt-[8px]"
        >
          {{ 'common.cancel' | translate }}
        </button>
      }
      <button
        (click)="onSubmit(cart.items)"
        [disabled]="form.invalid"
        dsw-primary-button
        dsw-medium-button
        class="mt-[8px]"
      >
        {{ saveButtonLabel }}
      </button>
    }
  </div>
</div>
